module.exports = __webpack_public_path__ + "static/media/signature.7e5a95d0.svg";